import { GridFilterModel } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';
import { useIssueStore } from '../store';
import {
  getIssueFilterModelApiSignature,
  getIssueFilterModelUiSignature,
  getUserFiltersCount,
} from '../models/filterModel/filterModel';

export {
  getUserFiltersCount,
};

export function useIssuesGridFilterModel() {
  const filterModel = useIssueStore.use.filterModel();
  const filterModelUiSignature = useIssueStore.use.filterModelUiSignature();
  const filterModelApiSignature = useIssueStore.use.filterModelApiSignature();
  const setFilterModel = useIssueStore.use.setFilterModel();
  const setParameters = useIssueStore.use.setParameters();

  const onFilterModelChange = useCallback(
    (model: GridFilterModel) => {
      const nextUiSignature = getIssueFilterModelUiSignature(model);
      const nextApiSignature = getIssueFilterModelApiSignature(model);

      if (filterModelUiSignature !== nextUiSignature) {
        setFilterModel(model);
      }

      if (filterModelApiSignature === nextApiSignature) {
        return false;
      }

      setParameters({
        offset: 0,
      });

      return true;
    },
    [
      filterModelApiSignature,
      filterModelUiSignature,
      setFilterModel,
      setParameters,
    ]
  );

  return {
    filterModel,
    onFilterModelChange,
  };
}
